export default "__VITE_ASSET__C8NZ5qfc__"